import { render, staticRenderFns } from "./RawMaterials.vue?vue&type=template&id=2c1db259&scoped=true&"
import script from "./RawMaterials.vue?vue&type=script&lang=js&"
export * from "./RawMaterials.vue?vue&type=script&lang=js&"
import style0 from "./RawMaterials.vue?vue&type=style&index=0&id=2c1db259&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1db259",
  null
  
)

export default component.exports